import { render, staticRenderFns } from "./SupplyingOfLotsDerive.vue?vue&type=template&id=19a2f661&scoped=true"
import script from "./SupplyingOfLotsDerive.vue?vue&type=script&lang=js"
export * from "./SupplyingOfLotsDerive.vue?vue&type=script&lang=js"
import style0 from "./SupplyingOfLotsDerive.vue?vue&type=style&index=0&id=19a2f661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2f661",
  null
  
)

export default component.exports